export default __webpack_public_path__ + "static/media/AdobeStock_321605471.1cb7ff5b.jpeg";